<template>
    <v-container fluid class="pa-5">
        <ConfirmDialog
            :is-open="showConfirmDialog"
            :data="confirmDialogData"
            @on-confirm="confirmDialogConfirm"
            @on-abort="confirmDialogClose"
        >
            <template #title>
                {{ confirmDialogData.title }}
            </template>
            <template #content>
                {{ confirmDialogData.content }}
            </template>
        </ConfirmDialog>

        <ShippingEditHistoryDialog
            :is-open="editHistoryDialog"
            :history="editHistory"
            @on-close="editHistoryDialog = false"
        />

        <PrintLabelTemplatesDialog
            :is-open="printLabelTemplatesDialog"
            :templates-to-print-data="templatesToPrint"
            :customer-id="shippingLabel.customer"
            :campaign-print="true"
            @on-close="closePrintLabelTemplatesDialog"
        />

        <page-title>{{ pageTitle }}</page-title>

        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row tag="form">
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <h2 class="text-h6">
                                            Parametry zawieszki
                                        </h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-text>
                                                <table class="table table--simple">
                                                    <tbody>
                                                        <tr>
                                                            <th>Data utworzenia:</th>
                                                            <td>{{ formatDate(shippingLabel.createdAt) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Utworzona przez:</th>
                                                            <td> {{ shippingLabel.createdBy.firstName }} {{ shippingLabel.createdBy.lastName }} </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <h2 class="text-h6">
                                            Dane klienta
                                        </h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-text>
                                                <table class="table table--simple">
                                                    <tbody>
                                                        <tr>
                                                            <th>Nazwa:</th>
                                                            <td>{{ shippingLabelCustomer.name }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>NIP:</th>
                                                            <td> {{ shippingLabelCustomer.nip }} </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Adres:</th>
                                                            <td>
                                                                {{ parseAddress(shippingLabelCustomer) }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Telefon:</th>
                                                            <td> {{ parseEmptyValue(shippingLabelCustomer.phoneNumber) }} </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-tabs
                                    v-model="tabs"
                                    slider-color="blue"
                                    grow
                                    background-color="grey lighten-4"
                                >
                                    <v-tab>
                                        Adresy
                                    </v-tab>
                                    <v-tabs-items v-model="tabs">
                                        <v-divider />
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-row v-if="shippingLabelPositions.length !== 0">
                                                        <v-col cols="12">
                                                            <v-row justify="end">
                                                                <v-col cols="auto">
                                                                    <v-btn
                                                                        color="primary"
                                                                        outlined
                                                                        medium
                                                                        data-sentry-label="Drukuj wszystko"
                                                                        :loading="isLoadingPrintAllLabels"
                                                                        @click="printAllShippingLabels"
                                                                    >
                                                                        Drukuj wszystko
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-if="shippingLabelPositions.length === 0">
                                                        <v-col cols="12">
                                                            <v-alert
                                                                type="info"
                                                                text
                                                                border="left"
                                                            >
                                                                Brak adresów.
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-else>
                                                        <v-col cols="12">
                                                            <v-expansion-panels
                                                                :key="addressComponentKey"
                                                                v-model="expandedPanels"
                                                                accordion
                                                                multiple
                                                            >
                                                                <v-expansion-panel v-for="(shippingLabelPosition, shippingLabelPositionIndex) in shippingLabelPositions" :key="shippingLabelPositionIndex">
                                                                    <v-expansion-panel-header color="grey lighten-4">
                                                                        <v-row no-gutters align="center" dense>
                                                                            <v-col cols="auto">
                                                                                <span>
                                                                                    <h1 class="text-subtitle-1">
                                                                                        <template>
                                                                                            <strong>{{ shippingLabelPositionIndex + 1 }}.</strong>
                                                                                            {{ parseEmptyValue(shippingLabelPosition.companyName) }}  {{ parseAddress(shippingLabelPosition) }}
                                                                                        </template>
                                                                                    </h1>
                                                                                </span>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-expansion-panel-header>
                                                                    <v-divider />
                                                                    <v-expansion-panel-content>
                                                                        <v-row>
                                                                            <v-col cols="12" md="5">
                                                                                <table class="table table--simple">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <th>Planowana data wysyłki:</th>
                                                                                            <td>{{ formatDate(shippingLabelPosition.expeditionDateTime) }}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th>Data dostawy:</th>
                                                                                            <td>{{ formatDate(shippingLabelPosition.deliveryDateTime) }}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th>Środek transportu:</th>
                                                                                            <td>{{ parseEmptyValue(shippingLabelPosition.transportType) }}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </v-col>
                                                                            <v-col cols="12" md="5" offset-md="2">
                                                                                <table class="table table--simple">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <th>Osoba kontaktowa:</th>
                                                                                            <td>
                                                                                                {{ parseEmptyValue(shippingLabelPosition.contactPerson) }}
                                                                                                <template v-if="shippingLabelPosition.phoneNumber">
                                                                                                    <br> tel. {{ shippingLabelPosition.phoneNumber }}
                                                                                                </template>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </v-col>
                                                                            <v-col cols="12">
                                                                                <v-container class="pa-0">
                                                                                    <v-row align="center">
                                                                                        <v-col cols="auto">
                                                                                            <strong>Pakowanie</strong>
                                                                                        </v-col>
                                                                                        <v-col cols="auto">
                                                                                            <v-btn
                                                                                                color="secondary"
                                                                                                fab
                                                                                                x-small
                                                                                                class="elevation-1 ml-4"
                                                                                                data-sentry-label="Dodaj pakowanie"
                                                                                                :loading="loadingPositionIndex === shippingLabelPositionIndex"
                                                                                                @click="addPositionPackage(shippingLabelPositionIndex)"
                                                                                            >
                                                                                                <v-icon>
                                                                                                    mdi-plus
                                                                                                </v-icon>
                                                                                            </v-btn>
                                                                                        </v-col>
                                                                                        <v-col cols="12" sm="">
                                                                                            <v-row justify="end">
                                                                                                <v-col cols="auto">
                                                                                                    <v-btn
                                                                                                        color="primary"
                                                                                                        outlined
                                                                                                        medium
                                                                                                        data-sentry-label="Usuń pakowania"
                                                                                                        :disabled="!shippingLabelPosition.shippingLabelPositionPackages.some(pkg => pkg.isSelected)"
                                                                                                        @click="deleteSelectedShippingLabelPositionPackages(shippingLabelPositionIndex)"
                                                                                                    >
                                                                                                        Usuń pakowania
                                                                                                    </v-btn>
                                                                                                </v-col>
                                                                                            </v-row>
                                                                                        </v-col>
                                                                                        <v-col v-if="!shippingLabelPosition.shippingLabelPositionPackages.length" cols="12">
                                                                                            <v-alert
                                                                                                type="info"
                                                                                                text
                                                                                                border="left"
                                                                                            >
                                                                                                Brak pakowania.
                                                                                            </v-alert>
                                                                                        </v-col>
                                                                                        <v-col v-else cols="12">
                                                                                            <v-expansion-panels
                                                                                                :key="packageComponentKey"
                                                                                                v-model="expandedNestedPanels[shippingLabelPositionIndex]"
                                                                                                accordion
                                                                                                multiple
                                                                                            >
                                                                                                <v-expansion-panel
                                                                                                    v-for="(shippingLabelPositionPackage, shippingLabelPositionPackageIndex) in shippingLabelPosition.shippingLabelPositionPackages"
                                                                                                    :key="shippingLabelPositionPackage.id"
                                                                                                >
                                                                                                    <v-expansion-panel-header color="grey lighten-4">
                                                                                                        <v-row no-gutters align="center" dense>
                                                                                                            <v-col cols="auto">
                                                                                                                <div class="mr-2" style="width: 24px; height: 24px;">
                                                                                                                    <v-simple-checkbox
                                                                                                                        v-if="!isFirstPackage(shippingLabelPositionPackageIndex)"
                                                                                                                        v-model="shippingLabelPositionPackage.isSelected"
                                                                                                                        :ripple="false"
                                                                                                                        class="mr-2"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="3">
                                                                                                                Sposób pakowania: <strong>{{ shippingLabelPositionPackage.boxTypeName }}</strong>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="5">
                                                                                                                Rodzaj opakowania: <strong>{{ shippingLabelPositionPackage.packageTypeName }}</strong>
                                                                                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                                                                                    <template #activator="{on}">
                                                                                                                        <v-icon color="primary" size="20" class="ml-2" v-on="on">
                                                                                                                            mdi-axis-arrow-info
                                                                                                                        </v-icon>
                                                                                                                    </template>
                                                                                                                    <span>
                                                                                                                        D: {{ shippingLabelPositionPackage.length }} <br>
                                                                                                                        SZ: {{ shippingLabelPositionPackage.width }} <br>
                                                                                                                        W: {{ shippingLabelPositionPackage.height }}
                                                                                                                    </span>
                                                                                                                </v-tooltip>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="2">
                                                                                                                Brutto: <strong>{{ formatWeight(roundWeight(shippingLabelPositionPackage.weight)) }}</strong>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="auto" class="ml-auto">
                                                                                                                <v-container fluid class="pa-0">
                                                                                                                    <v-row justify="end" dense>
                                                                                                                        <v-tooltip
                                                                                                                            :open-delay="tooltipDelay"
                                                                                                                            top
                                                                                                                        >
                                                                                                                            <template #activator="{on}">
                                                                                                                                <v-btn
                                                                                                                                    icon
                                                                                                                                    data-sentry-label="Drukuj etykietę paletową"
                                                                                                                                    :disabled="!hasGoods(shippingLabelPositionPackage) || hasChangesInGoods(shippingLabelPositionPackage) || shippingLabelPositionPackage.changed"
                                                                                                                                    v-on="on"
                                                                                                                                    @click="printLabel(shippingLabelPositionPackage, 'package')"
                                                                                                                                >
                                                                                                                                    <v-icon color="blue">
                                                                                                                                        mdi-printer
                                                                                                                                    </v-icon>
                                                                                                                                </v-btn>
                                                                                                                            </template>
                                                                                                                            <span>Drukuj etykietę paletową</span>
                                                                                                                        </v-tooltip>
                                                                                                                        <v-tooltip
                                                                                                                            v-if="!isFirstPackage(shippingLabelPositionPackageIndex)"
                                                                                                                            :open-delay="tooltipDelay"
                                                                                                                            top
                                                                                                                        >
                                                                                                                            <template #activator="{on}">
                                                                                                                                <v-btn
                                                                                                                                    icon
                                                                                                                                    data-sentry-label="Usuń pakowanie"
                                                                                                                                    v-on="on"
                                                                                                                                    @click.native="tryDeletePositionPackage(shippingLabelPositionIndex, shippingLabelPositionPackageIndex, $event)"
                                                                                                                                >
                                                                                                                                    <v-icon color="pink">
                                                                                                                                        mdi-delete
                                                                                                                                    </v-icon>
                                                                                                                                </v-btn>
                                                                                                                            </template>
                                                                                                                            <span>Usuń pakowanie</span>
                                                                                                                        </v-tooltip>
                                                                                                                    </v-row>
                                                                                                                </v-container>
                                                                                                            </v-col>
                                                                                                        </v-row>
                                                                                                    </v-expansion-panel-header>
                                                                                                    <v-divider />
                                                                                                    <!--  TOWARY -->
                                                                                                    <v-expansion-panel-content>
                                                                                                        <ShippingLabelCampaignPositionPackageGood
                                                                                                            :key="shippingLabel.version + shippingLabelPositionPackageIndex"
                                                                                                            :items="shippingLabelPositionPackage.shippingOrderPositionPackageGoods"
                                                                                                            :position-index="shippingLabelPositionIndex"
                                                                                                            :package-index="shippingLabelPositionPackageIndex"
                                                                                                            :first-package-goods="firstPositionPackageGoods(shippingLabelPositionIndex)"
                                                                                                            :label-position="shippingLabelPosition"
                                                                                                            @on-update="(...args) => updateData(...args, shippingLabelPositionIndex, shippingLabelPositionPackageIndex)"
                                                                                                            @on-print="(item) => printLabel(item, 'good')"
                                                                                                            @on-delete="(item) => deleteGoodFromPackage(item, shippingLabelPositionIndex, shippingLabelPositionPackageIndex)"
                                                                                                        />
                                                                                                    </v-expansion-panel-content>
                                                                                                    <!-- /TOWARY -->
                                                                                                </v-expansion-panel>
                                                                                            </v-expansion-panels>
                                                                                        </v-col>
                                                                                    </v-row>
                                                                                </v-container>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!-- /TAB ADDRESS -->
                                    </v-tabs-items>
                                </v-tabs>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container v-if="editHistory.length">
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-h6">
                                Historia zmian
                            </h2>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" lg="8">
                                            <strong>Ostatnio edytowany:</strong> {{ latestUpdatedBy }}
                                        </v-col>
                                        <v-col cols="12" lg="4">
                                            <v-row justify="end">
                                                <v-btn
                                                    color="primary"
                                                    class="mr-2"
                                                    outlined
                                                    small
                                                    @click="editHistoryDialog = true"
                                                >
                                                    Historia zmian
                                                </v-btn>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="success"
                                medium
                                data-sentry-label="Zapisz"
                                :loading="isLoading"
                                @click="save"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import { errorHandler } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import weightFormatter from '@/mixins/weightFormatter'
import parse from '@/mixins/parse'
import { openPdfFile } from '@/utils/pdfHandler'

const CAMPAIGN_PALLET_TEMPLATE_ID = 16
const CAMPAIGN_SET_TEMPLATE_ID = 17

export default {
    name: 'ShippingLabelCampaign',
    components: {
        PageTitle: () => import('@/components/common/PageTitle'),
        ConfirmDialog: () => import('@/components/common/ConfirmDialog.vue'),
        ShippingEditHistoryDialog: () => import('./Dialogs/ShippingEditHistoryDialog.vue'),
        ShippingLabelCampaignPositionPackageGood: () => import('./ShippingLabelCampaignPositionPackageGood.vue'),
        PrintLabelTemplatesDialog: () => import('./Dialogs/PrintLabelTemplatesDialog.vue'),
    },
    mixins: [
        parse,
        dateFormatter,
        tooltipDelay,
        weightFormatter,
    ],
    beforeRouteEnter(to, from, next) {
        store.dispatch('shipments/shipmentsLabels/getShippingLabel', to.params.id)
            .then(response => {
                const shippingLabel = response.data

                shippingLabel.shippingLabelPositions =
                    shippingLabel.shippingLabelPositions.sort((a, b) => a.id - b.id)

                next(vm => {
                    vm.pageTitle = `Zawieszki / Edycja etykiety - nr ${shippingLabel.number}`
                    vm.shippingLabel = shippingLabel
                    vm.shippingLabel.shippingLabelPositions = vm.shippingLabel.shippingLabelPositions.map(position => ({...position, disabled: true}))
                })
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    data() {
        return {
            loadingPositionIndex: null,
            expandedPanels: [],
            expandedNestedPanels: [],
            pageTitle: '',
            showConfirmDialog: false,
            confirmDialogData: {
                confirm: () => {},
            },
            editHistoryDialog: false,
            shippingLabel: {
                version: Date.now(),
                shippingLabelPositions: [],
                createdAt: null,
                createdBy: {
                    firstName: null,
                    lastName: null,
                }
            },
            tabs: 0,
            addressComponentKey: 0,
            packageComponentKey: 0,
            isLoading: false,
            isLoadingPrintAllLabels: false,
            printLabelTemplatesDialog: false,
            templatesToPrint: [],
            printShippingLabels: []
        }
    },
    computed: {
        shippingLabelCustomer() {
            return this.shippingLabel.shippingLabelCustomer || {
                name: null,
                nip: null,
            }
        },
        shippingLabelPositions() {
            return this.shippingLabel.shippingLabelPositions
        },
        editHistory() {
            return this.shippingLabel.editHistory || []
        },
        latestUpdatedBy() {
            if (!this.editHistory.length) {
                return ' - '
            }
            let fullName = `${this.editHistory[0]?.createdBy?.firstName} ${this.editHistory[0]?.createdBy?.lastName}`
            
            return `${fullName} ${this.formatDate(this.editHistory[0]?.createdAt)}`
        },
    },
    mounted() {
        this.shippingLabelPositions?.forEach((_, index) => {
            this.expandedPanels.push(index)
        })
        this.shippingLabelPositions?.forEach((shippingLabelPosition) => {
            const expandedIndexes = shippingLabelPosition.shippingLabelPositionPackages.map((_, index) => index)

            this.expandedNestedPanels.push(expandedIndexes)
        })
    },
    methods: {
        isFirstPosition(positionIndex) {
            return positionIndex === 0
        },
        isFirstPackage(packageIndex) {
            return packageIndex === 0
        },
        close() {
            this.$router.push({ name: 'shipmentsPackageLabelsLabels-v2' })
        },
        save() {
            this.isLoading = true
            store.dispatch('shipments/shipmentsLabels/updateShippingLabel', this.shippingLabel)
                .then(response => {
                    this.shippingLabel = response.data
                    this.shippingLabel.shippingLabelPositions.forEach(position => {
                        position.shippingLabelPositionPackages.forEach(pkg => {
                            pkg.changed = false
                            pkg.shippingOrderPositionPackageGoods.forEach(good => {
                                good.hasChanges = false
                            })
                        })
                    })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        parseAddress(address) {
            return address.street
                ? `${address.street}, ${address.postCode} ${address.city} ${this.parseEmptyValue(address.country && address.country?.name)}`
                : 'Brak adresu'
        },
        confirmDialogConfirm(payload) {
            this.confirmDialogData.confirm(payload)
            this.confirmDialogClose()
        },
        confirmDialogClose() {
            this.showConfirmDialog = false
            setTimeout(() => {
                this.confirmDialogData = {
                    title: null,
                    content: null,
                    confirm: () => {},
                    data: null,
                }
            }, 500)
        },
        hasGoods(positionPackage) {
            return positionPackage.shippingOrderPositionPackageGoods?.length > 0
        },
        hasChangesInGoods(positionPackage) {
            return positionPackage.shippingOrderPositionPackageGoods.some(good => good.hasChanges === true)
        },
        addPositionPackage(positionIndex) {
            this.loadingPositionIndex = positionIndex

            if (this.firstPositionPackageGoods(positionIndex)?.[0].amount < 2) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: 'Nie można dodać palety. Brakuje pakietów do rozpisania.'
                })
                this.loadingPositionIndex = null

                return
            }

            const firstPackage = this.shippingLabel.shippingLabelPositions[positionIndex].shippingLabelPositionPackages[0]
            const { id, ...packageWithoutId } = firstPackage
            const newPackage = {
                ...packageWithoutId,
                isSelected: false,
                shippingOrderPositionPackageGoods: [],
                printDateTime: null,
                uniqueNumber: null,
                version: Date.now()
            }

            this.shippingLabel.shippingLabelPositions[positionIndex].shippingLabelPositionPackages.push(newPackage)

            this.loadingPositionIndex = null
        },
        moveGoodsToFirstPackage(sourcePackage, firstPackage) {
            if (sourcePackage.shippingOrderPositionPackageGoods?.length > 0) {
                firstPackage.changed = true
            }
            sourcePackage.shippingOrderPositionPackageGoods.forEach(goodToMove => {
                const existingGoodIndex = firstPackage.shippingOrderPositionPackageGoods.findIndex(
                    good => good.goodName === goodToMove.goodName
                )

                if (existingGoodIndex !== -1) {
                    const good = firstPackage.shippingOrderPositionPackageGoods[existingGoodIndex]
                    
                    good.amount += goodToMove.amount
                    good.hasChanges = true

                } else {
                    const { id, ...goodWithoutId } = goodToMove

                    goodWithoutId.hasChanges = true
                    firstPackage.shippingOrderPositionPackageGoods.push({...goodWithoutId})
                }
            })
        },
        deleteSelectedShippingLabelPositionPackages(shippingLabelPositionIndex) {
            const position = this.shippingLabel.shippingLabelPositions[shippingLabelPositionIndex]
            const firstPackage = position.shippingLabelPositionPackages[0]

            position.shippingLabelPositionPackages.forEach(packageItem => {
                if (packageItem.isSelected) {
                    this.moveGoodsToFirstPackage(packageItem, firstPackage)
                }
            })

            position.shippingLabelPositionPackages = position.shippingLabelPositionPackages.filter(
                packageItem => !packageItem.isSelected
            )
            
            this.shippingLabel.version = Date.now()
        },
        tryDeletePositionPackage(positionIndex, positionPackageIndex, $event) {
            $event.stopPropagation()

            this.confirmDialogData = {
                title: 'Usuwanie pakowania',
                content: 'Czy na pewno chcesz usunąć pakowanie?',
                confirm: this.deletePositionPackage,
                data: {
                    positionIndex,
                    positionPackageIndex,
                },
            }
            this.showConfirmDialog = true
        },
        deletePositionPackage({ data }) {
            const { positionIndex, positionPackageIndex } = data
            const position = this.shippingLabel.shippingLabelPositions[positionIndex]
            const firstPackage = position.shippingLabelPositionPackages[0]
            const packageToDelete = position.shippingLabelPositionPackages[positionPackageIndex]

            this.moveGoodsToFirstPackage(packageToDelete, firstPackage)
            position.shippingLabelPositionPackages.splice(positionPackageIndex, 1)
            this.shippingLabel.version = Date.now()
        },
        firstPositionPackageGoods(index) {  
            return this.shippingLabel.shippingLabelPositions[index]?.shippingLabelPositionPackages[0]?.shippingOrderPositionPackageGoods || []
        },
        updateData(newPackageGoods, updatedOriginalGoods, shippingLabelPositionIndex, shippingLabelPositionPackageIndex) {
            const position = this.shippingLabel.shippingLabelPositions[shippingLabelPositionIndex]
            const firstPackage = position.shippingLabelPositionPackages[0]
            const goodsChanged = JSON.stringify(firstPackage.shippingOrderPositionPackageGoods) !== JSON.stringify(updatedOriginalGoods)

            // Check if there any changes even moving whole sets to next pallets
            if (goodsChanged) {
                firstPackage.changed = true
            }
            // Update first package goods with updated original goods
            firstPackage.shippingOrderPositionPackageGoods = updatedOriginalGoods
        
            if (position.shippingLabelPositionPackages.length > 1) {
                const existingGoods = position.shippingLabelPositionPackages[shippingLabelPositionPackageIndex].shippingOrderPositionPackageGoods || []

                newPackageGoods.forEach(newGood => {
                    const existingGoodIndex = existingGoods.findIndex(good => good.goodId === newGood.goodId)

                    if (existingGoodIndex === -1) {
                        existingGoods.push({...newGood})
                    } else {
                        existingGoods[existingGoodIndex].hasChanges = true
                        existingGoods[existingGoodIndex].amount += newGood.amount
                    }
                })
                position.shippingLabelPositionPackages[shippingLabelPositionPackageIndex].shippingOrderPositionPackageGoods = existingGoods
            }
            // Trigger reactivity
            this.shippingLabel.version = Date.now()
        },
        deleteGoodFromPackage(item, positionIndex, packageIndex) {
            const position = this.shippingLabel.shippingLabelPositions[positionIndex]
            const firstPackage = position.shippingLabelPositionPackages[0]
            const currentPackage = position.shippingLabelPositionPackages[packageIndex]

            // Only mark goods with the same name as the changed item
            position.shippingLabelPositionPackages.forEach(pkg => {
                pkg.shippingOrderPositionPackageGoods.forEach(good => {
                    if (good.goodName === item.goodName) {
                        good.hasChanges = true
                    }
                })
            })

            // Remove good from current package
            currentPackage.shippingOrderPositionPackageGoods = currentPackage.shippingOrderPositionPackageGoods.filter(
                good => good.goodName !== item.goodName
            )

            // Set change to current package
            currentPackage.changed = true
            // Set change to first package
            firstPackage.changed = true

            // Find if good exists in first package
            const existingGoodIndex = firstPackage.shippingOrderPositionPackageGoods.findIndex(
                good => good.goodName === item.goodName
            )

            if (existingGoodIndex !== -1) {
                const good = firstPackage.shippingOrderPositionPackageGoods[existingGoodIndex]
                
                good.amount += item.amount
                good.hasChanges = true
            } else {
                const { id, ...itemWithoutId } = item
                
                firstPackage.shippingOrderPositionPackageGoods.push({...itemWithoutId})
            }

            // Trigger reactivity
            this.shippingLabel.version = Date.now()
        },
        printAllShippingLabels() {
            this.isLoadingPrintAllLabels = true
            store.dispatch('shipments/shipmentsLabels/updateShippingLabel', this.shippingLabel)
                .then(response => {
                    this.shippingLabel = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.showPrintLabelTemplatesDialog()
                    this.isLoadingPrintAllLabels = false
                })
        },
        prepareDataToPrint(item, type) {
            const templates = {
                'good': {
                    name: item?.good?.goodName || '',
                    shippingLabelPositionPackageGoodId: item?.id,
                    shippingLabelTemplateId: CAMPAIGN_SET_TEMPLATE_ID,
                    templateName: 'Pakiet kampania'
                },
                'package': {
                    name: item?.boxTypeName || '',
                    shippingLabelPositionPackageId: item?.id,
                    shippingLabelTemplateId: CAMPAIGN_PALLET_TEMPLATE_ID,
                    templateName: 'Paleta kampania',
                    shippingOrderPositionPackageGoods: null
                }
            }

            if (!templates[type]) {
                return
            }

            this.templatesToPrint.push({
                ...templates[type]
            })
        },
        printLabel(item, type) {
            this.prepareDataToPrint(item, type)
            
            const payload = {
                'printShippingLabels': this.templatesToPrint
            }

            this.$store.dispatch(
                'shipments/shipmentsLabels/printShippingLabel',
                payload
            )
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.templatesToPrint = []
                })
        },
        async generateTemplatesToPrintList() {
            return this.shippingLabel.shippingLabelPositions?.forEach((address) => {
                address.shippingLabelPositionPackages.forEach((packageItem) => {
                    let templatesGoods = []

                    packageItem.shippingOrderPositionPackageGoods.forEach((goodItem) => {
                        let templateGood = {
                            name: goodItem.good.goodName,
                            shippingLabelPositionPackageGoodId: goodItem.id,
                            shippingLabelTemplateId: CAMPAIGN_SET_TEMPLATE_ID,
                            templateName: 'Pakiet kampania',
                            shippingLabelTemplateTypeId: null,
                            unitPackageType: goodItem.unitPackageType,
                            isSelected: false
                        }

                        templatesGoods.push(templateGood)
                    })
                    let templatePackage = {
                        name: packageItem.boxTypeName,
                        shippingLabelPositionPackageId: packageItem.id,
                        shippingLabelTemplateId: CAMPAIGN_PALLET_TEMPLATE_ID,
                        shippingLabelTemplateTypeId: null,
                        templateName: 'Paleta kampania',
                        shippingOrderPositionPackageGoods: templatesGoods,
                        isSelected: false
                    }

                    this.templatesToPrint.push(templatePackage)
                })
            })
        },
        showPrintLabelTemplatesDialog() {
            this.generateTemplatesToPrintList().then(() => this.printLabelTemplatesDialog = true)
        },
        closePrintLabelTemplatesDialog() {
            this.printLabelTemplatesDialog = false
            this.templatesToPrint = []
        },
    }
}
</script>
